<template>
  <div>
    <header>
      <v-container>
        <v-row no-gutters>
          <h1 class="font-weight-light headline">
            {{ $t("title.students") }}
          </h1>
          <v-spacer></v-spacer>
          <v-lazy v-if="isStudentsLoaded" transition="fade-transition">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              :label="searchLabel"
              single-line
              dense
              hide-details
              style="max-width: 200px"
              class="mr-5 pr-5"
            ></v-text-field>
          </v-lazy>
          <v-lazy transition="fade-transition">
            <v-btn
              color="success"
              dark
              small
              @click.stop="
                dialog.studentForm = true;
                isStudentEdited = false;
              "
              >{{ $t("general.add") }}</v-btn
            >
          </v-lazy>
        </v-row>
      </v-container>
    </header>
    <section class="py-7">
      <v-container>
        <v-sheet class="px-3 pt-3 pb-3" v-if="!isStudentsLoaded">
          <v-skeleton-loader class="mx-auto" type="table"></v-skeleton-loader>
        </v-sheet>
        <v-card v-else>
          <v-data-table :headers="headers" :items="students" :search="search">
            <template v-slot:item.action="{ item }">
              <div style="display: flex">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-icon
                      v-tr-class-on-hover="'blue'"
                      size="20px"
                      color="blue"
                      class="mr-2"
                      @click="editUser(item)"
                      v-on="on"
                      >mdi-pencil-outline</v-icon
                    >
                  </template>
                  <span>{{ $t("general.edit") }}</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-icon
                      size="22px"
                      color="red"
                      v-tr-class-on-hover="'red'"
                      class="mr-2"
                      @click="confirmDelete(item)"
                      v-on="on"
                      >mdi-delete-outline</v-icon
                    >
                  </template>
                  <span>{{ $t("general.delete") }}</span>
                </v-tooltip>
              </div>
            </template>
            <template v-slot:item.is_active="{ item }">
              <v-switch
                class="mt-0 pt-0 justify-content-center"
                hide-details
                color="green"
                v-model="item.is_active"
                @change="changeStatus(item)"
              ></v-switch>
            </template>
            <template v-slot:item.company="{ item }">
              <span v-if="item.company == null">-</span>
              <span v-else>{{ item.company.name }}</span>
            </template>
            <template v-slot:item.internal_id="{ item }">
              <span v-if="item.internal_id == null">-</span>
              <span v-else>{{ item.internal_id }}</span>
            </template>
            <template v-slot:item.division="{ item }">
              <span v-if="item.division == null">-</span>
              <span v-else>{{ item.division.name }}</span>
            </template>
            <template v-slot:item.section="{ item }">
              <span v-if="item.section == null">-</span>
              <span v-else>{{ item.section.name }}</span>
            </template>
          </v-data-table>
        </v-card>
        <StudentForm
          :student="selectedStudent"
          :visible="dialog.studentForm"
          :isEdited="isStudentEdited"
          :variables="variables"
          @addStudent="addStudent"
          @updateStudent="updateStudent"
          @close="dialog.studentForm = false"
          @snackMessage="snackMessage"
        />

        <ConfirmationDialog
          :name="selectedStudent.name"
          :text="'students.delete_confirmation'"
          v-if="dialog.confirmation"
          @confirm="deleteStudent"
          @cancel="cancelDelete"
        />

        <SnackMessage ref="SnackMessage" />
      </v-container>
    </section>
  </div>
</template>

<script>
import StudentForm from "../components/StudentForm.vue";
import ConfirmationDialog from "../components/ConfirmationDialog";
import SnackMessage from "../components/SnackMessage";

export default {
  data() {
    return {
      students: [],
      isStudentsLoaded: false,
      search: "",
      dialog: {
        confirmation: false,
        studentForm: false,
      },
      student: {
        name: null,
        id: null,
        email: null,
        identifier: null,
        last_name: null,
        company_id: null,
        internal_id: null,
        division_id: null,
        section_id: null,
        delivery_note_2: null,
        delivery_note: null,
        is_active: null,
      },
      selectedStudent: {
        name: null,
        id: null,
        email: null,
        identifier: null,
        last_name: null,
        company_id: null,
        internal_id: null,
        division_id: null,
        section_id: null,
        delivery_note_2: null,
        delivery_note: null,
        is_active: null,
      },
      defaultStudent: {
        name: null,
        id: null,
        email: null,
        identifier: null,
        last_name: null,
        company_id: null,
        internal_id: null,
        division_id: null,
        section_id: null,
        delivery_note_2: null,
        delivery_note: null,
        is_active: null,
      },
      isStudentEdited: false,
      variables: {
        app_domain: "",
        is_division: "",
        is_errors_available: "",
        app_name: "",
      },
    };
  },

  components: {
    StudentForm,
    ConfirmationDialog,
    SnackMessage,
  },

  computed: {
    headers() {
      
        return [
          {
            text: this.$t("general.actions"),
            value: "action",
            sortable: false,
          },
          {
            text: this.$t("students.identifier"),
            align: "left",
            sortable: false,
            value: "identifier",
          },
          {
            text: this.$t("students.name"),
            align: "left",
            sortable: false,
            value: "name",
          },
          {
            text: this.$t("students.last_name"),
            align: "left",
            sortable: false,
            value: "last_name",
          },
          {
            text: this.$t("students.email"),
            align: "left",
            sortable: false,
            value: "email",
          },
          {
            text: this.$t("students.is_active"),
            align: "left",
            sortable: false,
            value: "is_active",
          },
          {
            text: this.$t("general.created_at"),
            align: "left",
            sortable: false,
            value: "created_at",
          },
        ];
    },
    searchLabel() {
      return this.$t("general.search");
    },
  },

  created() {
    this.getStudents();
    this.getVariables();
  },

  methods: {
    getVariables() {
      axios
        .get("/getVariables", {
          headers: {
            Authorization:
              "Bearer " + this.$store.state.tokenData.user.access_token,
          },
        })
        .then((response) => {
          this.variables = response.data;
        });
    },
    snackMessage(msg, type) {
      this.$refs.SnackMessage.showMessage(msg, type);
    },
    async getStudents() {

      await axios
        .get("/studentList", {
          headers: {
            Authorization:
              "Bearer " + this.$store.state.tokenData.user.access_token,
          },
        })
        .then((response) => {
           this.students = response.data;
           this.isStudentsLoaded = true;
        })
        .catch((error) => {
          console.log(error.response.data);
        });
    },
    addStudent(student) {
      this.students.push(student);
      this.getStudents();
    },
    editUser(item) {
      this.selectedStudent = Object.assign({}, item);
      this.dialog.studentForm = true;
      this.isStudentEdited = true;
    },
    updateStudent(student) {
      let index = this.students.findIndex((item) => item.id == student.id);
      this.students.splice(index, 1, student);
      this.getStudents();
    },
    confirmDelete(item) {
      this.selectedStudent = item;
      this.dialog.confirmation = true;
    },
    cancelDelete() {
      this.dialog.confirmation = false;
    },
    async deleteStudent() {
      this.dialog.confirmation = false;
      let index = this.students.indexOf(this.selectedStudent);

      await axios
        .delete(`/deleteStudent/${this.selectedStudent.id}`, {
          headers: {
            Authorization:
              "Bearer " + this.$store.state.tokenData.user.access_token,
          },
        })
        .then((response) => {
          this.selectedStudent = this.defaultStudent;
          this.students.splice(index, 1);

          this.$refs.SnackMessage.showMessage(
            "students.deleted_successfully",
            "success"
          );
        })
        .catch((error) => {
          console.log(error);
          this.$refs.SnackMessage.showMessage("general.error", "error");
        });
    },
    async changeStatus(item) {
      try {
        const request = await axios.put(
          "/updateStatusStudent/" + item.id,
          item,
          {
            headers: {
              Authorization:
                "Bearer " + this.$store.state.tokenData.user.access_token,
            },
          }
        );
        this.getStudents();
        this.snackMessage("general.item_saved", "success");
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>
